<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleNextStep = async () => {
  await handleNext('tutorial_fog_of_war')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.fogOfWar.amazing') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.fogOfWar.scientistsExplained" tag="span">
          <template #scannerIcon><GenericIcon type="scanner"/></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        <i18n-t keypath="tutorial.fogOfWar.mapOnlyShows" tag="span">
          <template #scannerIcon><GenericIcon type="scanner"/></template>
        </i18n-t>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">{{ t('common.actions.understood') }}</ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>